import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'
import UtenlandsProfferListTemplate from './templates/UtenlandsProfferListTemplate'

function UtenlandsProffer() {
    const [proffer, setProffer] = useState([])

    useEffect(() => {
        try {
            const proffRef = firestore.collection('utenlandsproffer')
            proffRef.onSnapshot(({ docs }) => {
                const proffer = docs.map((doc) => {
                    return { id: doc.id, ...doc.data() }
                })
                setProffer(proffer)
            })
        } catch (error) {}
    }, [])

    return (
        <div>
            <h2 className="my-3 font-weight-bold">Norske utenlandsproffer</h2>
            <p>Viser {proffer?.length} utenlandsproffer</p>
            <div className="row">
                {proffer?.map((player, index) => {
                    return (
                        <UtenlandsProfferListTemplate
                            key={index}
                            player={player}
                        />
                    )
                })}
            </div>
        </div>
    )
}
export default UtenlandsProffer
